import React from 'react';
import { Controller } from 'react-hook-form';
import LabelName from 'components/UI/LabelName/LabelName';
import EventTypeSelect from 'components/UI/EventTypeSelect/EventTypeSelect';

function EventType({ control, watch }) {
  // Get practice area from case or prop
  const selectedCase = watch('case');
  const pa = watch('practice_area');

  const practiceArea = selectedCase?.practice_area || pa?.value || '';

  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-md-4 col-12 p-medium">
        <LabelName required={false} htmlFor="event_type">
          Event Type
        </LabelName>
      </div>
      <div className="col-md-8 col-12">
        <Controller
          name="event_type.event_type"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <EventTypeSelect
              id={field.name}
              name={field.name}
              value={field.value}
              onChange={(value) => field.onChange(value || '')}
              onBlur={field.onBlur}
              placeholder="Event Type"
              isClearable={!!field.value}
              practiceAreaId={practiceArea}
              showQuickAdd={true}
              isSearchable={true}
            />
          )}
        />
      </div>
    </div>
  );
}

export default EventType;
